import React, { useEffect, useRef } from 'react'
import styled from 'styled-components'
import { useLastTruthy } from '../../hooks/useLast'
import { AdvancedSwapDetails, AdvancedSwapDetailsProps } from './AdvancedSwapDetails'

const AdvancedDetailsFooter = styled.div`
  padding-top: 16px;
  padding-bottom: 20px;
  width: 100%;
  max-width: 400px;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  color: ${({ theme }) => theme.text2};
  background-color: ${({ theme }) => theme.advancedBG};
  z-index: 1;
  
  transition: all 300ms ease-in-out;
`

export default function AdvancedSwapDetailsDropdown({ trade, ...rest }: AdvancedSwapDetailsProps) {
  const lastTrade = useLastTruthy(trade)
  const slideRef = useRef<undefined|HTMLElement>()

  useEffect(() => {
    const bool = Boolean(trade)
    const dom = slideRef.current!
    const height = dom.offsetHeight
    dom.style.display = 'block'
    if (bool) {
      dom.style.marginTop = -1 * height + 'px'
      setTimeout(() => {
        dom.style.marginTop = '0px'
      })
    } else {
      dom.style.marginTop = '0px'
      setTimeout(()=>{
        dom.style.marginTop = -1 * height + 'px'
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Boolean(trade)])
  return (
    <AdvancedDetailsFooter ref={slideRef as any}>
      <AdvancedSwapDetails {...rest} trade={trade ?? lastTrade ?? undefined} />
    </AdvancedDetailsFooter>
  )
}


// import React, { useEffect, useState, useRef } from 'react'
// import styled from 'styled-components'
// import { useLastTruthy } from '../../hooks/useLast'
// import { AdvancedSwapDetails, AdvancedSwapDetailsProps } from './AdvancedSwapDetails'

// const AdvancedDetailsFooter = styled.div<{ show: boolean }>`
//   padding-top: calc(16px + 2rem);
//   padding-bottom: 20px;
//   margin-top: -2rem;
//   width: 100%;
//   max-width: 400px;
//   border-bottom-left-radius: 20px;
//   border-bottom-right-radius: 20px;
//   color: ${({ theme }) => theme.text2};
//   background-color: ${({ theme }) => theme.advancedBG};
//   z-index: 1;

//   transform: ${({ show }) => (show ? 'translateY(0%)' : 'translateY(-100%)')};
//   transition: transform 1000ms ease-in-out;
// `

// export default function AdvancedSwapDetailsDropdown({ trade, ...rest }: AdvancedSwapDetailsProps) {
//   const lastTrade = useLastTruthy(trade)
//   const [show, setShow] = useState<boolean>(false)
//   const slideRef = useRef<undefined|HTMLElement>()
//   const cbRef = useRef<()=>void>()

//   cbRef.current = () => {
//     const dom = slideRef.current!
//     if (!show) {
//       dom.style.display = 'none'
//     }
//   }

//   useEffect(() => {
//     const dom = slideRef.current!
//     dom.addEventListener('transitionend', () => {
//       cbRef.current!()
//     })
//   }, [])

//   useEffect(() => {
//     const bool = Boolean(trade)
//     const dom = slideRef.current!
//     if (bool) {
//       dom.style.display = 'block'
//       setTimeout(()=>{
//         setShow(bool)
//       })
//     } else {
//       setShow(false)
//     }
//   }, [Boolean(trade)])

//   return (
//     <AdvancedDetailsFooter show={show} ref={slideRef as any}>
//       <AdvancedSwapDetails {...rest} trade={trade ?? lastTrade ?? undefined} />
//     </AdvancedDetailsFooter>
//   )
// }
